import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { to: '/services', label: 'Services' },
  { to: '/projects', label: 'Work' },
  { to: '/process', label: 'Process' },
  { to: '/blog', label: 'Blog' },
];

export default function Navbar({ onTalkClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 z-50 w-full transition-all ${
        scrolled ? 'border-b border-slate-200 bg-white/90 backdrop-blur shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="relative mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <Link to="/" className="text-xl font-semibold tracking-tight text-slate-900">
          Anorc Inc
        </Link>

        <div className="flex items-center gap-4">
          <ul className="hidden items-center gap-8 lg:flex">
            {links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm font-medium text-slate-600 transition hover:text-slate-900"
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="tel:14374944736"
                className="text-sm font-semibold text-slate-900 transition hover:text-blue-600"
              >
                1‑437‑494‑4736
              </a>
            </li>
          </ul>

          <button
            type="button"
            onClick={onTalkClick}
            className="hidden rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white shadow hover:opacity-90 lg:inline-flex"
          >
            Let’s Talk →
          </button>

          <button
            type="button"
            className="relative inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 text-slate-900 transition hover:bg-slate-50 lg:hidden"
            aria-label="Toggle navigation"
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span
              className={`absolute block h-0.5 w-6 bg-current transition-transform ${
                open ? 'translate-y-0 rotate-45' : '-translate-y-2'
              }`}
            />
            <span
              className={`absolute block h-0.5 w-6 bg-current transition-opacity ${
                open ? 'opacity-0' : 'opacity-100'
              }`}
            />
            <span
              className={`absolute block h-0.5 w-6 bg-current transition-transform ${
                open ? 'translate-y-0 -rotate-45' : 'translate-y-2'
              }`}
            />
          </button>
        </div>
        {open ? (
          <div className="absolute left-0 top-full w-full bg-white px-6 pb-6 pt-4 shadow-lg lg:hidden">
            <ul className="space-y-4 text-center">
              {links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="block rounded-2xl border border-slate-200 px-4 py-3 text-center text-base font-medium text-slate-700 transition hover:bg-slate-50"
                    onClick={() => setOpen(false)}
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="tel:14374944736"
                  onClick={() => setOpen(false)}
                  className="block rounded-2xl border border-slate-200 px-4 py-3 text-center text-base font-semibold text-slate-900 transition hover:bg-slate-50"
                >
                  1‑437‑494‑4736
                </a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setOpen(false);
                    onTalkClick?.();
                  }}
                  className="flex w-full items-center justify-center rounded-2xl bg-slate-900 px-4 py-3 text-base font-semibold text-white shadow hover:opacity-90"
                >
                  Let’s Talk →
                </button>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    </nav>
  );
}
